(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno-xpress/assets/react/hooks/use-local-storage.js') >= 0) return;  svs.modules.push('/modules/keno-xpress/assets/react/hooks/use-local-storage.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useCallback = _React.useCallback,
  useState = _React.useState;
const useLocalStorage = function (key) {
  let initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let expirationTimeMS = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  const _useState = useState(() => {
      try {
        const item = window.localStorage.getItem(key);
        const itemValue = item ? JSON.parse(item) : initialValue;
        const now = new Date().getTime();
        const hasExpired = expirationTimeMS && (itemValue === null || itemValue === void 0 ? void 0 : itemValue.exp) && itemValue.exp < now;
        if (hasExpired) {
          return initialValue;
        }
        return itemValue;
      } catch (error) {
        return initialValue;
      }
    }),
    _useState2 = _slicedToArray(_useState, 2),
    storedValue = _useState2[0],
    setStoredValue = _useState2[1];
  const setValue = useCallback(value => {
    setStoredValue(storedValue => {
      try {
        const valueToStore = typeof value === 'function' ? value(storedValue) : value;
        if (expirationTimeMS) {
          valueToStore.exp = new Date().getTime() + expirationTimeMS;
        }
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
        return valueToStore;
      } catch (error) {
        return storedValue;
      }
    });
  }, [key, expirationTimeMS]);
  return [storedValue, setValue];
};
svs.kenoXpress.react.hooks.useLocalStorage = useLocalStorage;

 })(window);